import {
  ArrowTopRightOnSquareIcon,
  BanknotesIcon,
  BoltIcon,
  CreditCardIcon,
  ChatBubbleLeftRightIcon,
  DocumentTextIcon,
  EnvelopeIcon,
  ExclamationTriangleIcon,
  GlobeAltIcon,
  PhoneIcon,
} from '@heroicons/react/24/outline';

import { IHeroIcon } from '../types/types';

export type IconMapKey =
  | `callCustomerWithAI`
  | `sendReminderEmail`
  | `sendSms`
  | `issueLateFee`
  | `raiseEscalation`
  | `viewInvoiceActions`
  | `viewContactStatement`
  | `viewInAccountingSystem`
  | `viewInCustomerPortal`
  | `createPaymentPlan`
  | `payWithSavedCard`;

export const iconMap: Record<IconMapKey, IHeroIcon> = {
  callCustomerWithAI: PhoneIcon,
  sendReminderEmail: EnvelopeIcon,
  sendSms: ChatBubbleLeftRightIcon,
  issueLateFee: BanknotesIcon,
  raiseEscalation: ExclamationTriangleIcon,
  viewInvoiceActions: BoltIcon,
  viewContactStatement: DocumentTextIcon,
  viewInAccountingSystem: ArrowTopRightOnSquareIcon,
  viewInCustomerPortal: GlobeAltIcon,
  createPaymentPlan: BanknotesIcon,
  payWithSavedCard: CreditCardIcon,
};
